<template>
    <div class="content-wrapper">
        <section class="content-header">
            <h1>
                {{ $t('edit') }} {{ $t('brand.brand') }}
                <template v-if="isLoaded && brand.name"> - {{ brand.name }} </template>

                <div class="pull-right">
                    <router-link
                        v-if="brand.name"
                        :to="{ name: 'brands.show', params: { id: brandId } }"
                        class="btn btn-sm btn-primary"
                    >
                        <span class="sr-only">{{ $t('brand.backToBrand') }}</span>
                        <span class="hidden-xs">{{ $t('brand.backToBrand') }}</span>
                        <span class="visible-xs">
                            <i class="fa fa-arrow-left"></i>
                        </span>
                    </router-link>

                    <router-link
                        v-else
                        :to="{ name: 'brands.list' }"
                        class="btn btn-sm btn-default"
                    >
                        <span class="sr-only">{{ $t('brand.brandsList') }}</span>
                        <span class="hidden-xs">{{ $t('brand.brandsList') }}</span>
                        <span class="visible-xs">
                            <i class="fa fa-list-ul"></i>
                        </span>
                    </router-link>
                </div>
            </h1>
        </section>

        <section class="content">
            <Alerts />

            <div class="row">
                <div class="col-xs-12">
                    <div class="box box-primary">
                        <div
                            v-if="!isLoaded"
                            class="box-body with-border clearfix"
                        >
                            <img
                                class="table-row-preloader center-block"
                                rel="preload"
                                src="/img/table-row-preloader.gif"
                            />
                        </div>

                        <BrandsForm
                            v-show="isLoaded"
                            :brandId="brandId"
                            @loaded="onLoaded"
                        />
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import BrandsForm from '@/components/brands/BrandsForm.vue';

export default {
    components: {
        BrandsForm,
    },
    data() {
        return {
            isLoaded: false,
            brandId: Number(this.$route.params.id),
            brand: {},
        };
    },
    computed: {
        headTitle() {
            return this.brand.name && `${this.$t('brand.brand')} ${this.brand.name} ${this.$t('edit')}`;
        },
    },
    methods: {
        onLoaded(brand) {
            this.brand = brand;
            this.isLoaded = true;
        },
    },
};
</script>
